import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=b55fd284&scoped=true"
import script from "./TemplateModal.vue?vue&type=script&lang=js"
export * from "./TemplateModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateModal.vue?vue&type=style&index=0&id=b55fd284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55fd284",
  null
  
)

export default component.exports